import DatetimeParser from '../../model/parser/datetime-parser'

export class SchedulerTaskValueObject {
  static IDtTask          = 'IDtTask'
  static tTask_SearchText = 'tTask_SearchText'
  static IDtUserGroup     = 'IDtUserGroup'
  static ResourceID       = 'ResourceID'
  static BeginDateSched   = 'BeginDateSched'
  static EndDateSched     = 'EndDateSched'
  static Duration         = 'Duration'

  /**
   *
   * @param id
   * @param name
   * @param duration
   * @param idUserGroup
   * @param beginDate
   * @param endDate
   */
  constructor (
    id, name, duration, idUserGroup = null, beginDate = null, endDate = null) {
    this._id          = id
    this._name        = name
    this._idUserGroup = idUserGroup
    this._beginDate   = beginDate
    this._endDate     = endDate
    this._duration    = duration
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get id () {
    return this._id
  }

  get endDate () {
    return this._endDate
  }

  get beginDate () {
    return this._beginDate
  }

  get idUserGroup () {
    return this._idUserGroup
  }

  get duration () {
    return this._duration
  }

  get calendarDuration () {
    let date = new Date()
    date     = new Date(date.setHours(this.duration, 0, 0, 0))
    return DatetimeParser.dateObjectToTime(date)
  }

  /**
   *
   * @param apiObject
   * @returns {SchedulerTaskValueObject}
   */
  static fromApiObject (apiObject) {
    return new SchedulerTaskValueObject(
      apiObject[SchedulerTaskValueObject.IDtTask],
      apiObject[SchedulerTaskValueObject.tTask_SearchText],
      apiObject[SchedulerTaskValueObject.Duration]
    )
  }

  /**
   *
   * @returns {{}}
   */
  toApiObject () {
    let output = {}

    output[SchedulerTaskValueObject.IDtTask]          = this.id
    output[SchedulerTaskValueObject.IDtUserGroup]     = this.idUserGroup
    output[SchedulerTaskValueObject.ResourceID]       = this.idUserGroup
    output[SchedulerTaskValueObject.tTask_SearchText] = this.name
    output[SchedulerTaskValueObject.BeginDateSched]   = this.beginDate
    output[SchedulerTaskValueObject.EndDateSched]     = this.endDate

    return output
  }

}
